import { connect } from "react-redux";
import { FornecedorViewProps, mapDispatchToFornecedorProps, mapStateToFornecedorProps } from "../forn.controll";
import { Fornecedor } from "../forn.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { FornecedorCadastro } from "./forn.cad";
 
export const columnsFornecedor: GridColDef[] = [
    { field: 'nome', headerName: 'nome', flex: 3 },
    { field: 'apelido', headerName: 'Fantasia', flex: 3 },
    { field: 'whatsapp', headerName: 'WhatsApp', flex: 2 },
    { field: 'n_doc', headerName: 'Documento', flex: 2 },
    { field: 'email', headerName: 'Email', flex: 2 },
]

function FornecedorList(props: FornecedorViewProps) {
    const { fornecedorActions,fornecedorState } = props
    const { error, loadingRows, msg, row, rows, showAlert, showDialogExluir, status,showCadModal,changeList } = fornecedorState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue,setShowCadModal } = fornecedorActions
    console.log("FornecedorList props ",props)

    useEffect(()=>{
        read()
    },[])

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: any) => {
        console.log("chamou handleAlterar")
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        console.log("chamou handleCloseCadastro")
        setShowCadModal(false)
    }

    function Cadastro() {
        return FornecedorCadastro({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            heigth: "auto",
        })
    }

    const List = ()=>{
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Fornecedores Cadastrados"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"nome"}
                columns={columnsFornecedor}
                rows={rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick:()=>read()
                }}
                ListItemTextPrimary={(row: Fornecedor) => <Typography component={"span"}>{row.nome} {row.sobrenome}</Typography>}
                ListItemTextSecondary={(row: Fornecedor) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>{row.apelido} {row.whatsapp}</Typography>
                        {row.enderecos.length > 0 && (
                            <Typography component={"span"}>{row.enderecos[row.idx_endereco_main].rua}</Typography>
                        )}

                    </Box>
                }
            />
        )
    }

    return (
        <div className="modulo">
            <Cadastro />
            <List />
        </div>
    )

}

export default connect(mapStateToFornecedorProps,mapDispatchToFornecedorProps)(FornecedorList);
